module.exports = __webpack_public_path__ + "static/media/project1.6ac4bb68.png";